// externals
import React, { useState, useEffect } from 'react'
import styled from '@emotion/styled'
import { arrayOf, number, shape, string } from 'prop-types'

// utils
import { getLatAndLongByGeolocation } from '@jelly/utils'

// components
import { GoogleMapsReactWrap } from './GoogleMapsReactWrap'
import { MapMarker } from './MapMarker'
import { MapYouAreHereBox } from './MapYouAreHereBox'

const Wrapper = styled.div`
	overflow: hidden;
	width: 100%;
	height: 100%;
`

NearYouMap.propTypes = {
	center: shape({
		lat: number,
		lng: number,
	}),
	services: arrayOf(
		shape({
			id: string.isRequired,
		})
	),
	userCenter: shape({
		lat: number.isRequired,
		lng: number.isRequired,
	}),
	zoom: number,
}

/**
 * NearYouMap
 *
 * A Google map along with pins for companies near user's current location.
 * The map API is pre-loaded in the base .twig
 * Set the "you are here" coordinates for the map. Defaults to Purch in Ogden.
 * This value is where a marker is dropped and is the initial center of the map. It can be
 * overwritten by incoming coordinates via the `center` prop.
 */
export function NearYouMap({ zoom = 8, center, services }) {
	const [userCenter, setUserCenter] = useState({})

	useEffect(() => {
		const fetchData = async () => {
			const latLongObj = await getLatAndLongByGeolocation()

			setUserCenter({
				...latLongObj,
			})
		}

		fetchData()
	}, [])

	return (
		<Wrapper>
			<GoogleMapsReactWrap center={{ ...userCenter, ...center }} zoom={zoom}>
				<MapMarker
					RenderMapInfoBox={MapYouAreHereBox}
					fillPrimary="#00449E"
					fillSecondary="#76C4E2"
					zIndex="998"
					{...userCenter}
				/>
				{services.map((service) => (
					<MapMarker fillPrimary="#E7040F" fillSecondary="#FF725C" key={service.id} {...service} />
				))}
			</GoogleMapsReactWrap>
		</Wrapper>
	)
}
